import { render, staticRenderFns } from "./AuditCouponDetail.vue?vue&type=template&id=1b680560&scoped=true&"
import script from "./AuditCouponDetail.vue?vue&type=script&lang=ts&"
export * from "./AuditCouponDetail.vue?vue&type=script&lang=ts&"
import style0 from "./AuditCouponDetail.vue?vue&type=style&index=0&id=1b680560&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b680560",
  null
  
)

export default component.exports